import {
  isMobilePhone,
  isMobileTablet,
} from '../../library/calc';
import './Iconbox.css';
import {
  imageBasePath,
  borderColor,
  fontFamily,
} from '../../library/constants';
import React, { Component } from 'react';

// import { translateMenuItemActions } from './moreMenuActions';

class IconboxFanchart extends Component {

  constructor(props){
    super(props);
  }


  render () {

    let {
      idx,
      imgFile,
      iconBoxSide,
      action,
      label,
      nodeForFlipFocus,
      nodeObjs,
      flipData,
      fetchIsLoading,
      showHookMessageForNearbyTreeMatches,
    } = this.props;

    let iconBoxStyle = {
      position: 'relative',
      whiteSpace: 'nowrap',
      float: `left`,
      width: `${ iconBoxSide }px`,
      height: `${ iconBoxSide }px`,
      fontSize: '13px',
      fontFamily: `${ fontFamily }`,
      padding: '4px 0px',
      boxSizing: 'border-box',
      borderWidth: `1px`,
      borderStyle: `solid`,
      borderColor: borderColor,
      cursor: 'pointer',
      opacity: 1,
      borderRightWidth: '1px',
      borderLeftWidth: '0px',
    }

    let divImgStyle = {
      backgroundImage: `url(${imageBasePath}${imgFile})`,
      backgroundSize: '35px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      width: `${ iconBoxSide }px`,
      height: `${ iconBoxSide }px`,
      opacity: .6,
      position: 'absolute',
      cursor: 'pointer',
    };

    const textStyle = {
      textAlign: `center`
    }

    const classNames = ['icon-boxes']

    return (
      <div className={classNames} style={iconBoxStyle}

      >
        <div>
          <div style={divImgStyle}></div>
        </div>
        <div style={textStyle} >
          {label}
        </div>
      </div>
    );
  }
}

export default IconboxFanchart;

